//
//
//
//
//
//
//
//
//
//

export default {
  name: 'App',
  data(){
    return {
      show:false
    }
  },
  watch:{
    $route(){
      var ua = navigator.userAgent.toLowerCase();    
      if (/iphone|ipad|ipod/.test(ua)) {
              if(this.$route.path!='/tiwn'){
                this.show = true
              }else{
                this.show = false
              }       
      } else if (/android/.test(ua)) {
              this.show = false  
      }
      
    }
  },
  mounted(){
    var ua = navigator.userAgent.toLowerCase();    
      if (/iphone|ipad|ipod/.test(ua)) {
              if(this.$route.path!='/tiwn'){
                this.show = true
              }else{
                this.show = false
              }       
      } else if (/android/.test(ua)) {
              this.show = false  
      }
  },
  methods:{
    back(){
      history.back()
    }
  }

}



// WEBPACK FOOTER //
// ./src/App.vue